import { ReportsTab } from '../components/ReportsTab';
import { ModuleGuide } from '@/shared/components/ui/ModuleGuide';

export function AccountsReportsPage() {
  return (
    <div className="p-6 space-y-4">
      <div><h1 className="text-2xl font-semibold tracking-tight">Financial Reports</h1><p className="text-sm text-muted-foreground mt-1">Trial Balance, Profit & Loss, Balance Sheet, Tax Summary and more</p></div>
      <ModuleGuide
        summary="Reports are not separately entered data — they are built automatically from the ledger entries of posted invoices, bills, payments, expenses, payroll and journals."
        steps={['Choose a date range.', 'The report groups posted ledger entries by account type.', 'If a figure looks wrong, check the original voucher/invoice/bill and the Audit Trail.']}
        formulas={[
          { label: 'Profit / Loss', formula: 'Income − Expenses' },
          { label: 'Balance Sheet', formula: 'Assets = Liabilities + Equity' },
          { label: 'GST payable', formula: 'Output GST on sales − Input GST on purchases' },
          { label: 'Trial Balance check', formula: 'Total Debit = Total Credit' },
        ]}
      />
      <ReportsTab />
    </div>
  );
}
